<template>
  <div class="home">
    <el-row>
      <el-col :span="17">
        <el-row>
          <el-col :span="12">
            <el-card class="card" style="height: 45vh">
              <div class="x-flex title">
                <div class="x-m-l-12 f600 x-font-15">伙伴排行</div>
                <div class="x-m-l-10 c-7">七日活跃排行</div>
              </div>
              <div class="x-m-t-10">
                <div style="width: 100%" class="bgc-e x-m-t-15"></div>
                <div class="x-flex x-row-left x-m-t-15 x-p-t-20 x-bd-top f600" style="color: #4988ff">
                  <div class="x-font-14 x-m-r-20">
                    商户总数：{{ sh_total.sh_count }}
                  </div>
                  <div class="x-font-14 x-m-r-20">
                    七日活跃：{{ sh_total.sh_7day_count }}
                  </div>
                  <!-- <div class="x-font-14 x-m-r-20">
                    今日新增：{{ sh_total.new_sh_count }}
                  </div> -->
                  <div class="x-font-14 x-m-r-20">
                    今日活跃：{{ sh_total.jr_login }}
                  </div>
                </div>
              </div>
              <div id="echarts-merchant" style="width: 100%; height: 35vh; margin-top: -20px"></div>
            </el-card>
          </el-col>
          <el-col :span="12" class="">
            <el-card class="card" style="height: 45vh">
              <div class="x-flex title">
                <div class="x-m-l-12 f600 x-font-15">七日新增</div>
                <div class="x-m-l-10 c-7">近七天内新增商户</div>
              </div>
              <div class="content">
                <div style="width: 100%" class="bgc-e x-m-t-15"></div>
                <div class="x-flex x-row-left x-m-t-15 x-p-t-20 x-bd-top f600" style="color: #4988ff">
                  <div class="x-font-14 x-m-r-20">
                    商户总数：{{ sh_total.sh_count }}
                  </div>
                  <div class="x-font-14 x-m-r-20">
                    七日活跃：{{ sh_total.sh_7day_count }}
                  </div>
                  <div class="x-font-14 x-m-r-20">
                    今日新增：{{ sh_total.new_sh_count }}
                  </div>
                </div>
              </div>
              <div id="echarts-sh-num" style="width: 100%; height: 35vh; margin-top: -20px"></div>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-card class="card x-m-t-8">
              <el-carousel trigger="click" height="39vh">
                <el-carousel-item>
                  <img src="../../src/assets/img/banner1.png" alt="" style="width: 100%" />
                </el-carousel-item>
                <el-carousel-item>
                  <img src="../../src/assets/img/banner2.png" alt="" style="width: 100%" />
                </el-carousel-item>
              </el-carousel>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="7">
        <el-col>
          <el-card style="height: 45vh">
            <div class="x-flex title">
              <div class="x-m-l-12 f600 x-font-15">最近收入</div>
              <div class="x-m-l-10 c-7">
                按新用户估算，实际分润以客户实际支付为准
              </div>
            </div>
            <div class="content">
              <div style="width: 100%" class="bgc-e x-m-t-15"></div>
              <div class="x-flex x-row-left x-m-t-15 x-p-t-20 x-bd-top f600" style="color: #4988ff">
                <div class="x-font-14 x-m-r-20">
                  收入总额：{{ bykApi.numHelper.fMoneyFat(sh_total.nf_money) }}
                </div>
                <div class="x-font-14 x-m-r-20">
                  七日收入：{{
                    bykApi.numHelper.fMoneyFat(sh_total.nf_7day_money)
                  }}
                </div>
                <div class="x-font-14 x-m-r-20">
                  今日新增：{{ sh_total.new_nf_money }}
                </div>
              </div>
            </div>
            <div id="echarts-profit" style="width: 100%; height: 35vh; margin-top: -20px"></div>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="x-m-t-8">
            <div style="height: 39vh">
              <div class="x-flex title">
                <div class="x-m-l-12 f600 x-font-15">
                  {{ homeData.comp_name }}
                </div>
              </div>
              <div class="x-flex x-row-between x-m-t-15 x-p-t-20 x-p-b-20 x-bd-top">
                <div class="x-flex">
                  <img src="../assets/img/home-icon-1.png" alt="" style="width: 26px; height: 26px" />
                  <div class="x-m-l-8">可注册门店数</div>
                </div>
                <div class="f600">{{ homeData.can_reg_user_num }}</div>
              </div>
              <div class="x-flex x-row-between x-p-t-20 x-p-b-20 x-bd-top">
                <div class="x-flex">
                  <img src="../assets/img/home-icon-2.png" alt="" style="width: 26px; height: 26px" />
                  <div class="x-m-l-8">已注册门店数</div>
                </div>
                <div class="f600">{{ homeData.reg_user_num }}</div>
              </div>
              <div class="x-flex x-row-between x-p-t-20 x-p-b-20 x-bd-top">
                <div class="x-flex">
                  <img src="../assets/img/home-icon-3.png" alt="" style="width: 26px; height: 26px" />
                  <div class="x-m-l-8">合作方式</div>
                </div>
                <div class="f600">{{ homeData.hz_way }}</div>
              </div>
              <div class="x-flex x-row-between x-p-t-20 x-bd-top">
                <div class="x-flex">
                  <img src="../assets/img/home-icon-4.png" alt="" style="width: 26px; height: 26px" />
                  <div class="x-m-l-8">到期时间</div>
                </div>
                <div class="f600">{{ homeData.stop_time }}</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  // import * as echarts from "echarts";

  export default {
    data() {
      return {
        homeData: {},
        merchantEcharts: "",
        profitEcharts: "",
        shNumEcharts: "",
        merchantOption: {
          color: ["#80FFA5"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            data: ["Line 1"],
            left: "center",
            bottom: "bottom",
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "0%",
            containLabel: true,
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: [],
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                fontSize: 10, //更改坐标轴文字大小
              },
            },
          }, ],
          yAxis: [{
            type: "value",
          }, ],
          series: [{
            name: "",
            type: "line",
            stack: "总量",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "#52cdd5",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [],
          }, ],
        },
        profitOption: {
          color: ["#778dd1"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            data: ["Line 1"],
            left: "center",
            bottom: "bottom",
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "10%",
            containLabel: true,
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: [],
          }, ],
          yAxis: [{
            type: "value",
          }, ],
          series: [{
            name: "",
            type: "line",
            stack: "总量",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "#ff3f0caa",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [],
          }, ],
        },

        shNumOption: {
          color: ["#3196ff"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#3196ff",
              },
            },
          },
          legend: {
            data: ["Line 1"],
            left: "center",
            bottom: "bottom",
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "10%",
            containLabel: true,
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: [],
          }, ],
          yAxis: [{
            type: "value",
          }, ],
          series: [{
            name: "",
            type: "line",
            stack: "总量",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "#3196ffaa",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [],
          }, ],
        },
        sh_total: {
          nf_7day_money: "0",
          nf_money: "0",
          sh_7day_count: "0",
          sh_count: "0",
        },
      };
    },
    created() {
      this.init();
      window.onresize = () => {
        this.merchantEcharts.resize();
        this.profitEcharts.resize();
        this.shNumEcharts.resize();
        return;
      };
      // setTimeout(() => {
      //   this.merchantEcharts.resize();
      //   this.profitEcharts.resize();
      // }, 0);
    },
    mounted() {},
    methods: {
      async init() {
        let res = await this.fBykGetPatrnerPlatformHomeData();
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.homeData = res.data[0];
        this.bykApi.global.fSetPlatform({
          partnerInfo: {
            data: res.data[0],
          },
        });
        this.homeData.stop_time = this.homeData.stop_time.split(" ")[0];
        // 组装图表一的参数
        res.partner_7day_count_detail.forEach((item) => {
          this.merchantOption.xAxis[0].data.unshift(item.comp_name.substr(0, 5));
          this.merchantOption.series[0].data.unshift(Number(item.sh_add));
        });
        if (res.partner_7day_count_detail.length == 1) {
          this.merchantOption.xAxis[0].data.unshift("");
          this.merchantOption.xAxis[0].data.push("");
          this.merchantOption.series[0].data.unshift(0);
          this.merchantOption.series[0].data.push(0);
        }
        // 组装图表二的参数
        res.reg_7day_money_detail.forEach((item) => {
          this.profitOption.xAxis[0].data.push(item.creat_day);
          this.profitOption.series[0].data.push(Number(item.nf_money));
        });
        if (res.reg_7day_money_detail.length == 1) {
          this.profitOption.xAxis[0].data.unshift("");
          this.profitOption.xAxis[0].data.push("");
          this.profitOption.series[0].data.unshift(0);
          this.profitOption.series[0].data.push(0);
        }
        // 组装图表三的参数
        res.reg_7day_money_detail.forEach((item) => {
          this.shNumOption.xAxis[0].data.push(item.creat_day);
          this.shNumOption.series[0].data.push(Number(item.sh_add));
        });
        if (res.reg_7day_money_detail.length == 1) {
          this.shNumOption.xAxis[0].data.unshift("");
          this.shNumOption.xAxis[0].data.push("");
          this.shNumOption.series[0].data.unshift(0);
          this.shNumOption.series[0].data.push(0);
        }

        // sh_total 数据
        this.sh_total = res.sh_total;


        this.myMerchartEcharts();
        this.myProfitEcharts();
        this.myShNumEcharts();
      },

      // 活跃商户图表
      myMerchartEcharts() {
        this.merchantEcharts = this.$echarts.init(
          document.getElementById("echarts-merchant")
        );
        this.merchantEcharts.setOption(this.merchantOption);
      },
      // 每日分润图表
      myProfitEcharts() {
        this.profitEcharts = this.$echarts.init(
          document.getElementById("echarts-profit")
        );
        this.profitEcharts.setOption(this.profitOption);
      },
      // 七日新增图表
      myShNumEcharts() {
        this.shNumEcharts = this.$echarts.init(
          document.getElementById("echarts-sh-num")
        );
        this.shNumEcharts.setOption(this.shNumOption);
      },

      // 获取首屏数据
      async fBykGetPatrnerPlatformHomeData() {
        let js = {};
        js["PARTNER_PHONE"] = this.bykApi.global.fGetPlatform().partnerInfo.phone;
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_PATRNER_PLATFROM_HOME_DATA ', js);
        return res;
      },
    },
  };
</script>

<style lang='less' scoped>
  .home {
    // height: calc(100vh - 70px);
    // background-color: rgb(255, 199, 199);

    overflow: auto;

    .title {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        display: block;
        width: 3px;
        height: 13px;
        background-color: #409eff;
        border-radius: 2px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .tips {
      position: relative;
      padding-left: 10px;

      &::before {
        content: "";
        display: block;
        width: 6px;
        height: 4px;
        background-color: #409eff;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .tips-heat {
      padding: 1px;
      background-color: #e6521e;
      font-size: 12px;
      line-height: 12px;
      border-radius: 3px;
      margin-right: 2px;
      color: #fff;
    }

    /deep/ .el-card.card {
      margin-right: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue